import React from "react";
import { Link } from "react-router-dom";

/**
 * Shared layout for inner pages (/about, /podcast, etc.)
 * - Matches the dark navy/gold/serif aesthetic of the hero
 * - Each page is a clean placeholder ready to be expanded later
 */
const PageShell = ({
  eyebrow,
  title,
  intro,
  children,
  testId,
}) => {
  return (
    <main data-testid={testId} className="bg-ink min-h-screen">
      {/* Page hero */}
      <section className="relative hero-vignette pt-28 lg:pt-32 pb-14 lg:pb-18 border-b border-white/5">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-12">
          <div className="text-[11px] tracking-[0.32em] uppercase text-gold fade-in-up">
            {eyebrow}
          </div>
          <h1
            className="mt-6 font-serif text-white text-[32px] sm:text-[44px] lg:text-[54px] leading-[1.04] tracking-[-0.01em] fade-in-up"
            style={{ animationDelay: "120ms" }}
          >
            {title}
          </h1>
          <div className="mt-8 h-px w-20 bg-gold" />
          {intro && (
            <p
              className="mt-8 text-white/75 text-[17px] leading-[1.85] max-w-2xl fade-in-up"
              style={{ animationDelay: "240ms" }}
            >
              {intro}
            </p>
          )}
        </div>
      </section>

      {/* Page content */}
      <section className="max-w-[1100px] mx-auto px-6 lg:px-12 py-14 lg:py-18">
        {children}
      </section>

      {/* Bottom CTA back */}
      <section className="border-t border-white/5">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-12 py-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <div className="text-[11px] tracking-[0.32em] uppercase text-gold">
              Continue
            </div>
            <div className="font-serif text-white text-2xl mt-2">
              Return to the homepage
            </div>
          </div>
          <Link
            to="/"
            data-testid="page-shell-home-link"
            className="inline-flex items-center text-[11px] tracking-[0.32em] uppercase border border-white/40 hover:border-gold hover:text-gold text-white px-7 py-4 transition-all duration-300"
          >
            ← Home
          </Link>
        </div>
      </section>
    </main>
  );
};

export default PageShell;
